(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.az-products__alpha').addEventListener('click', function (event) {
      event.preventDefault();
      if (event.target.tagName == 'A') {
        let btn = event.target;
        document.querySelector('.az-products__alpha a.active').classList.remove('active');
        btn.classList.add('active');
        document.querySelector(`${btn.getAttribute('href')}`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('.hero-banner__action__button');
    const listWrap = document.querySelector('.hero-banner__link__list-wrap');

    if (!button || !listWrap) return;

    button.addEventListener('click', function () {
      button.classList.toggle('active');
      listWrap.classList.toggle('visible');
    });

    function openHeroLinksFromHash() {
      if (window.location.hash === '#hero-banner__links') {
        button.classList.add('active');
        listWrap.classList.add('visible');
      }
    }

    openHeroLinksFromHash();

    window.addEventListener('hashchange', openHeroLinksFromHash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-calendar-old"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const memberSelect = document.querySelector('#member');
    const memberTrigger = document.querySelector('#member-trigger');
    const memberOptions = document.querySelector('#member-options');
    const memberSelected = document.querySelector('#member-selected');
    const hoursContainer = document.querySelector('.booking-calendar__hours');
    const dateInput = document.querySelector('#date');
    const dateField = document.querySelector('.booking-calendar__picker__date');
    const memberHiddenInput = document.querySelector('#booking-prop-member');
    const variantIdInput = document.querySelector('#booking-variant-id');
    const addToCartBtn = document.querySelector('.booking-calendar__add-to-cart');
    let flatpickrInstance = null;

    function getMinBookingDate() {
      return new Date(Date.now() + 48 * 60 * 60 * 1000);
    }

    function getCurrentIntervenant() {
      return window.bookingData[memberSelect.value];
    }
    function normalizeDateKey(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
    function parseDateKey(dateKey) {
      const parts = String(dateKey).split('-').map(Number);
      return parts.length === 3 && !parts.some(Number.isNaN) ? new Date(parts[0], parts[1] - 1, parts[2]) : null;
    }
    function isSameDay(a, b) {
      return normalizeDateKey(a) === normalizeDateKey(b);
    }
    function getSelectedHourInput() {
      return hoursContainer.querySelector('input[name="properties[Heure]"]:checked:not(:disabled)');
    }
    function updateAddToCartState() {
      addToCartBtn.disabled = !(variantIdInput.value && dateInput.value && getSelectedHourInput());
    }
    function getAvailabilityForDate(intervenant, date) {
      return intervenant.availability.find((disponibilite) => disponibilite.date === normalizeDateKey(date));
    }
    function parseHourToDate(selectedDate, hourText) {
      const match = String(hourText).match(/(\d{1,2})(?:[:hH](\d{2}))?/);
      if (!match) return null;
      const slotDate = new Date(selectedDate);
      slotDate.setHours(Number(match[1]), Number(match[2] || 0), 0, 0);
      return slotDate;
    }
    function hasAvailableFutureHour(intervenant, date) {
      const disponibilite = getAvailabilityForDate(intervenant, date);
      const cutoff = getMinBookingDate();
      return Boolean(disponibilite && disponibilite.heures && disponibilite.heures.some(item => {
        const slot = parseHourToDate(date, item.heure);
        return slot && slot > cutoff;
      }));
    }
    function isDateSelectable(intervenant, date) {
      const cutoff = getMinBookingDate();
      const cutoffDay = new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate());
      if (date < cutoffDay) return false;
      return Boolean(getAvailabilityForDate(intervenant, date)) && (!isSameDay(date, cutoff) || hasAvailableFutureHour(intervenant, date));
    }
    function getFirstAvailableDate(intervenant) {
      const cutoff = getMinBookingDate();
      const cutoffDay = new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate());
      return intervenant.availability.map(item => parseDateKey(item.date)).filter(Boolean).filter(date => date >= cutoffDay).sort((a, b) => a - b).find(date => isDateSelectable(intervenant, date)) || null;
    }

    function updateMemberDisplay() {
      const intervenant = getCurrentIntervenant();
      memberSelected.textContent = '';
      if (!intervenant) return;
      if (intervenant.image) {
        const image = document.createElement('img');
        image.src = intervenant.image;
        image.alt = '';
        image.className = 'booking-member-select__image';
        memberSelected.appendChild(image);
      }
      const name = document.createElement('span');
      name.textContent = intervenant.nom;
      memberSelected.appendChild(name);
    }

    function formatHourLabel(date) {
      return `${String(date.getHours()).padStart(2, '0')}h${String(date.getMinutes()).padStart(2, '0')}`;
    }

    function renderHours(intervenant, selectedDate) {
      hoursContainer.innerHTML = '';
      const disponibilite = getAvailabilityForDate(intervenant, selectedDate);
      if (!disponibilite || !disponibilite.heures || !disponibilite.heures.length) {
        hoursContainer.innerHTML = '<p class="booking-calendar__hours__empty">Aucune disponibilité ce jour-là.</p>';
        return;
      }
      const now = new Date();
      let hasAvailableHour = false;
      disponibilite.heures.forEach((item, index) => {
        const isPast = parseHourToDate(selectedDate, item.heure) <= now;
        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'btn-check';
        input.name = 'properties[Heure]';
        input.id = `heure-${index}`;
        input.value = item.heure;
        input.disabled = isPast;
        input.addEventListener('change', updateAddToCartState);
        const label = document.createElement('label');
        label.className = 'btn btn-secondary';
        label.htmlFor = input.id;
        label.textContent = item.heure;
        if (isPast) {
          label.classList.add('disabled');
          label.setAttribute('aria-disabled', 'true');
        } else {
          hasAvailableHour = true;
        }
        hoursContainer.append(input, label);
      });
      if (!hasAvailableHour)
        hoursContainer.insertAdjacentHTML(
          'beforeend',
          '<p class="booking-calendar__hours__empty">Tous les créneaux de ce jour sont passés.</p>'
        );
      updateAddToCartState();
    }

    function buildCalendar(intervenant) {
      const firstAvailableDate = getFirstAvailableDate(intervenant);
      if (flatpickrInstance) flatpickrInstance.destroy();
      flatpickrInstance = flatpickr(dateField, {
        inline: true,
        altInput: true,
        locale: 'fr',
        minDate: 'today',
        enable: [(date) => isDateSelectable(intervenant, date)],
        onReady: (dates, value, instance) => {
          if (firstAvailableDate) instance.jumpToDate(firstAvailableDate);
        },
        onChange: (selectedDates) => {
          dateInput.value = selectedDates[0] ? normalizeDateKey(selectedDates[0]) : '';
          if (selectedDates[0]) renderHours(intervenant, selectedDates[0]);
          else {
            hoursContainer.innerHTML = '';
            updateAddToCartState();
          }
        },
      });
      dateInput.value = '';
      hoursContainer.innerHTML = `<p class="booking-calendar__hours__empty">${
        firstAvailableDate ? 'Sélectionnez une date pour voir les horaires.' : 'Aucune disponibilité.'
      }</p>`;
      updateAddToCartState();
    }

    memberTrigger.addEventListener('click', function () {
      const isOpen = !memberOptions.hidden;
      memberOptions.hidden = isOpen;
      memberTrigger.setAttribute('aria-expanded', String(!isOpen));
    });
    memberOptions.addEventListener('click', function (event) {
      const option = event.target.closest('[data-member-index]');
      if (!option) return;
      memberSelect.value = option.dataset.memberIndex;
      memberOptions.hidden = true;
      memberTrigger.setAttribute('aria-expanded', 'false');
      memberSelect.dispatchEvent(new Event('change'));
    });
    memberSelect.addEventListener('change', function () {
      const intervenant = getCurrentIntervenant();
      if (!intervenant) return;
      buildCalendar(intervenant);
      memberHiddenInput.value = intervenant.nom;
      updateMemberDisplay();
    });

    const firstIntervenant = getCurrentIntervenant();
    if (firstIntervenant) {
      buildCalendar(firstIntervenant);
      memberHiddenInput.value = firstIntervenant.nom;
      updateMemberDisplay();
    }

    const handle = new URLSearchParams(window.location.search).get('product');
    const productDetails = document.querySelector('.booking-calendar__details__product');
    if (handle)
      fetch(`/products/${handle}.js`)
        .then((response) => {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then((product) => {
          productDetails.innerHTML = `<h3>${product.title}</h3><p>${product.description}</p>`;
          const variant = product.variants.find((item) => item.available);
          if (variant) {
            variantIdInput.value = variant.id;
            updateAddToCartState();
          }
        })
        .catch((error) => {
          console.error(error);
          productDetails.textContent = 'Produit introuvable.';
        });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-calendar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const memberSelect = document.querySelector('#member');
    const memberTrigger = document.querySelector('#member-trigger');
    const memberOptions = document.querySelector('#member-options');
    const memberSelected = document.querySelector('#member-selected');
    const hoursContainer = document.querySelector('.booking-calendar__hours');
    const dateInput = document.querySelector('#date');
    const dateField = document.querySelector('.booking-calendar__picker__date');
    const memberHiddenInput = document.querySelector('#booking-prop-member');
    const variantIdInput = document.querySelector('#booking-variant-id');
    const addToCartBtn = document.querySelector('.booking-calendar__add-to-cart');
    let flatpickrInstance = null;

    // Mode « agenda de service » : le produit a son propre agenda (ex. Mon tirage privé).
    const handle = new URLSearchParams(window.location.search).get('product');
    const service = handle && window.bookingServices ? window.bookingServices[handle] : null;
    const reservedSlots = new Set();
    if (service) {
      window.bookingData = [service.intervenant];
      (window.bookingReserves || [])
        .filter((item) => item && item.produit === handle)
        .forEach((item) => reservedSlots.add(`${item.date}|${normalizeHour(item.heure)}`));
      const pageTitle = document.querySelector('.booking-calendar__title');
      if (pageTitle && service.titre) pageTitle.textContent = service.titre;
      const memberBlock = document.querySelector('.booking-calendar__member');
      if (memberBlock) memberBlock.classList.add('d-none');
      if (memberSelect && !memberSelect.options.length) memberSelect.add(new Option(service.intervenant.nom, '0'));
      if (memberSelect) memberSelect.value = '0';
    }

    function normalizeHour(hourText) {
      const match = String(hourText).match(/(\d{1,2})(?:[:hH](\d{2}))?/);
      return match ? `${String(match[1]).padStart(2, '0')}:${match[2] || '00'}` : String(hourText);
    }
    function isReserved(date, hourText) {
      return service ? reservedSlots.has(`${normalizeDateKey(date)}|${normalizeHour(hourText)}`) : false;
    }

    function getCurrentIntervenant() {
      return window.bookingData[service ? 0 : memberSelect.value];
    }
    function normalizeDateKey(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
    function parseDateKey(dateKey) {
      const parts = String(dateKey).split('-').map(Number);
      return parts.length === 3 && !parts.some(Number.isNaN) ? new Date(parts[0], parts[1] - 1, parts[2]) : null;
    }
    function isSameDay(a, b) {
      return normalizeDateKey(a) === normalizeDateKey(b);
    }
    function getSelectedHourInput() {
      return hoursContainer.querySelector('input[name="properties[Heure]"]:checked:not(:disabled)');
    }
    function updateAddToCartState() {
      addToCartBtn.disabled = !(variantIdInput.value && dateInput.value && getSelectedHourInput());
    }
    function getAvailabilityForDate(intervenant, date) {
      return intervenant.availability.find((disponibilite) => disponibilite.date === normalizeDateKey(date));
    }
    function parseHourToDate(selectedDate, hourText) {
      const match = String(hourText).match(/(\d{1,2})(?:[:hH](\d{2}))?/);
      if (!match) return null;
      const slotDate = new Date(selectedDate);
      slotDate.setHours(Number(match[1]), Number(match[2] || 0), 0, 0);
      return slotDate;
    }

    function getMinBookingDate() {
      return new Date(Date.now() + 48 * 60 * 60 * 1000);
    }

    function addThirtyMinutes(heureText) {
      const match = String(heureText).match(/^(\d{1,2})([:hH])(\d{2})$/);
      if (!match) return heureText;
      const [, hh, sep, mm] = match;
      let totalMinutes = (parseInt(hh, 10) * 60 + parseInt(mm, 10) + 30) % (24 * 60);
      const newHours = Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      return `${String(newHours).padStart(2, '0')}${sep}${String(newMinutes).padStart(2, '0')}`;
    }

    // Libellé affiché : inchangé pour le parcours historique, heure exacte pour un agenda de service.
    function hourLabel(heureText) {
      return service ? normalizeHour(heureText).replace(':', 'h') : addThirtyMinutes(heureText);
    }

    function hasAvailableFutureHour(intervenant, date) {
      const disponibilite = getAvailabilityForDate(intervenant, date);
      const cutoff = getMinBookingDate();
      return Boolean(
        disponibilite &&
          disponibilite.heures &&
          disponibilite.heures.some((item) => {
            const slot = parseHourToDate(date, item.heure);
            return slot && slot > cutoff && !isReserved(date, item.heure);
          })
      );
    }

    function isDateSelectable(intervenant, date) {
      const cutoff = getMinBookingDate();
      const cutoffDay = new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate());
      if (date < cutoffDay) return false;
      if (service) return hasAvailableFutureHour(intervenant, date);
      return (
        Boolean(getAvailabilityForDate(intervenant, date)) &&
        (!isSameDay(date, cutoff) || hasAvailableFutureHour(intervenant, date))
      );
    }

    function getFirstAvailableDate(intervenant) {
      const cutoff = getMinBookingDate();
      const cutoffDay = new Date(cutoff.getFullYear(), cutoff.getMonth(), cutoff.getDate());
      return (
        intervenant.availability
          .map((item) => parseDateKey(item.date))
          .filter(Boolean)
          .filter((date) => date >= cutoffDay)
          .sort((a, b) => a - b)
          .find((date) => isDateSelectable(intervenant, date)) || null
      );
    }

    function updateMemberDisplay() {
      const intervenant = getCurrentIntervenant();
      memberSelected.textContent = '';
      if (!intervenant) return;
      if (intervenant.image) {
        const image = document.createElement('img');
        image.src = intervenant.image;
        image.alt = '';
        image.className = 'booking-member-select__image';
        memberSelected.appendChild(image);
      }
      const name = document.createElement('span');
      name.textContent = intervenant.nom;
      memberSelected.appendChild(name);
    }

    function renderHours(intervenant, selectedDate) {
      hoursContainer.innerHTML = '';
      const disponibilite = getAvailabilityForDate(intervenant, selectedDate);
      if (!disponibilite || !disponibilite.heures || !disponibilite.heures.length) {
        hoursContainer.innerHTML = '<p class="booking-calendar__hours__empty">Aucune disponibilité ce jour-là.</p>';
        return;
      }
      const now = getMinBookingDate();
      let hasAvailableHour = false;
      disponibilite.heures.forEach((item, index) => {
        const reserved = isReserved(selectedDate, item.heure);
        if (reserved) return; // créneau déjà vendu : il n'est plus proposé
        const startDate = parseHourToDate(selectedDate, item.heure);
        const isPast = startDate <= now;
        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'btn-check';
        input.name = 'properties[Heure]';
        input.id = `heure-${index}`;
        input.value = item.heure;
        input.disabled = isPast;
        input.addEventListener('change', updateAddToCartState);
        const label = document.createElement('label');
        label.className = 'btn btn-secondary';
        label.htmlFor = input.id;
        label.textContent = hourLabel(item.heure);
        if (isPast) {
          label.classList.add('disabled');
          label.setAttribute('aria-disabled', 'true');
        } else {
          hasAvailableHour = true;
        }
        hoursContainer.append(input, label);
      });
      if (!hasAvailableHour)
        hoursContainer.insertAdjacentHTML(
          'beforeend',
          '<p class="booking-calendar__hours__empty">Plus aucun créneau disponible ce jour-là.</p>'
        );
      updateAddToCartState();
    }

    function buildCalendar(intervenant) {
      const firstAvailableDate = getFirstAvailableDate(intervenant);
      if (flatpickrInstance) flatpickrInstance.destroy();
      flatpickrInstance = flatpickr(dateField, {
        inline: true,
        altInput: true,
        locale: 'fr',
        minDate: getMinBookingDate(),
        enable: [(date) => isDateSelectable(intervenant, date)],
        onReady: (dates, value, instance) => {
          if (firstAvailableDate) instance.jumpToDate(firstAvailableDate);
        },
        onChange: (selectedDates) => {
          dateInput.value = selectedDates[0] ? normalizeDateKey(selectedDates[0]) : '';
          if (selectedDates[0]) renderHours(intervenant, selectedDates[0]);
          else {
            hoursContainer.innerHTML = '';
            updateAddToCartState();
          }
        },
      });
      dateInput.value = '';
      hoursContainer.innerHTML = `<p class="booking-calendar__hours__empty">${
        firstAvailableDate ? 'Sélectionnez une date pour voir les horaires.' : 'Aucune disponibilité.'
      }</p>`;
      updateAddToCartState();
    }

    memberTrigger.addEventListener('click', function () {
      const isOpen = !memberOptions.hidden;
      memberOptions.hidden = isOpen;
      memberTrigger.setAttribute('aria-expanded', String(!isOpen));
    });
    memberOptions.addEventListener('click', function (event) {
      const option = event.target.closest('[data-member-index]');
      if (!option) return;
      memberSelect.value = option.dataset.memberIndex;
      memberOptions.hidden = true;
      memberTrigger.setAttribute('aria-expanded', 'false');
      memberSelect.dispatchEvent(new Event('change'));
    });
    memberSelect.addEventListener('change', function () {
      const intervenant = getCurrentIntervenant();
      if (!intervenant) return;
      buildCalendar(intervenant);
      memberHiddenInput.value = intervenant.nom;
      updateMemberDisplay();
    });

    const firstIntervenant = getCurrentIntervenant();
    if (firstIntervenant) {
      buildCalendar(firstIntervenant);
      memberHiddenInput.value = firstIntervenant.nom;
      updateMemberDisplay();
    }

    const productDetails = document.querySelector('.booking-calendar__details__product');
    if (handle)
      fetch(`/products/${handle}.js`)
        .then((response) => {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then((product) => {
          productDetails.innerHTML = `<h3>${product.title}</h3><p>${product.description}</p>`;
          const variant = product.variants.find((item) => item.available);
          if (variant) {
            variantIdInput.value = variant.id;
            updateAddToCartState();
          }
        })
        .catch((error) => {
          console.error(error);
          productDetails.textContent = 'Produit introuvable.';
        });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choice-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const imgs = document.querySelectorAll('.choice-cta__images img');
    const btns = document.querySelectorAll('.choice-cta__tabs__wrapper button.nav-link');

    let currentImg = document.querySelector('.choice-cta__images img.show');
    let cleanupTimeout = null;

    btns.forEach(btn => {
      btn.addEventListener('shown.bs.tab', function (event) {
        const nextImg = document.querySelector(event.target.getAttribute('data-image'));
        if (!nextImg || nextImg === currentImg) return;

        if (cleanupTimeout) {
          clearTimeout(cleanupTimeout);
          cleanupTimeout = null;
          imgs.forEach(img => {
            if (img !== currentImg) {
              img.classList.remove('show');
              img.style.transform = '';
              img.style.opacity = '';
              img.style.transition = '';
            }
          });
        }

        const allImgs = [...imgs];
        const currentIndex = allImgs.indexOf(currentImg);
        const nextIndex = allImgs.indexOf(nextImg);

        if (nextIndex > currentIndex) {
          nextImg.style.transform = 'translateY(100%)';
          nextImg.style.opacity = '0';
          nextImg.style.transition = 'none';
          nextImg.classList.add('show');

          nextImg.getBoundingClientRect();

          nextImg.style.transition = '';
          nextImg.style.transform = 'translateY(0)';
          nextImg.style.opacity = '1';
          currentImg.style.transform = 'translateY(-100%)';
          currentImg.style.opacity = '0';

        } else {
          nextImg.style.transform = 'translateY(-100%)';
          nextImg.style.opacity = '0';
          nextImg.style.transition = 'none';
          nextImg.classList.add('show');

          nextImg.getBoundingClientRect();

          nextImg.style.transition = '';
          nextImg.style.transform = 'translateY(0)';
          nextImg.style.opacity = '1';
          currentImg.style.transform = 'translateY(100%)';
          currentImg.style.opacity = '0';
        }

        const prevImg = currentImg;
        currentImg = nextImg;

        cleanupTimeout = setTimeout(() => {
          prevImg.classList.remove('show');
          prevImg.style.transform = '';
          prevImg.style.opacity = '';
          prevImg.style.transition = '';
          cleanupTimeout = null;
        }, 920);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  new Swiper('.collections-products__pills__contents_products', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

    breakpoints: {
      0: {
        slidesPerView: 1.1,
      },
      520: {
        slidesPerView: 1.8,
      },
      790: {
        slidesPerView: 2.3,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collections-tabs__pills__contents_products').forEach(function (swiperEl) {
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;

      new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          0: { slidesPerView: 1.1 },
          520: { slidesPerView: 1.8 },
          790: { slidesPerView: 2.5 },
          1197: { slidesPerView: 4 },
        },
        on: {
          init: function (swiper) {
            centerIfNeeded(swiper, slideCount);
          },
          resize: function (swiper) {
            centerIfNeeded(swiper, slideCount);
          },
        },
      });
    });

    function centerIfNeeded(swiper, slideCount) {
      const perView = Math.round(swiper.params.slidesPerView);
      const wrapper = swiper.wrapperEl;

      if (slideCount < perView) {
        wrapper.style.justifyContent = 'center';
      } else {
        wrapper.style.justifyContent = '';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-podcast"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cta-podcast__player__card-audio').forEach(container => {
        if (container) {
            let src = container.dataset.src;
            let audio = new Audio(src);
            let speeds = [1, 1.5, 2, 0.75];
            let speedIdx = 0;

            container.innerHTML = `
                <div class="ap-timeline">
                    <span class="ap-time" id="ap-cur">00:00</span>
                    <div class="ap-progress" id="ap-bar">
                        <div class="ap-fill" id="ap-fill"></div>
                        <div class="ap-thumb" id="ap-thumb"></div>
                    </div>
                    <span class="ap-time total" id="ap-total">--:--</span>
                </div>
                <div class="ap-controls">
                    <div class="ap-speed" id="ap-speed">x1</div>
                    <div class="ap-btn" id="ap-back">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26" viewBox="0 0 22 26" fill="none">
                            <g clip-path="url(#clip0_11503_9263)">
                            <path d="M1.73959 10.7296C0.887251 12.8239 0.769871 15.1453 1.4066 17.315C2.04334 19.4846 3.3966 21.3745 5.24556 22.6761C7.09452 23.9777 9.33003 24.6142 11.5873 24.4819C13.8446 24.3495 15.9904 23.456 17.6746 21.9473C19.3587 20.4385 20.4818 18.4034 20.8606 16.1742C21.2394 13.945 20.8515 11.6533 19.7603 9.67286C18.669 7.69246 16.9387 6.14037 14.8519 5.26984C12.765 4.3993 10.4447 4.26173 8.26959 4.87955" stroke="#BF3C00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 1.5L8 5L12 8.5" stroke="#BF3C00" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M8.28523 13.1H6.75523V12.51C7.27523 12.5033 7.63857 12.4767 7.84523 12.43C8.0519 12.3767 8.19523 12.2733 8.27523 12.12C8.35523 11.9667 8.41523 11.69 8.45523 11.29H9.02523V18.5H8.28523V13.1ZM12.6091 18.58C11.9157 18.58 11.3357 18.4 10.8691 18.04C10.4024 17.6733 10.1257 17.1767 10.0391 16.55L10.7291 16.39H10.7691C10.8357 16.87 11.0324 17.2467 11.3591 17.52C11.6857 17.7933 12.0991 17.93 12.5991 17.93C13.1191 17.93 13.5357 17.7633 13.8491 17.43C14.1624 17.0967 14.3191 16.6633 14.3191 16.13C14.3191 15.57 14.1557 15.1267 13.8291 14.8C13.5091 14.4667 13.0757 14.3 12.5291 14.3C11.8624 14.3 11.3391 14.6067 10.9591 15.22H10.2591L10.7991 11.29H14.7891V11.94H11.3391L11.0091 14.31C11.2091 14.1233 11.4557 13.9733 11.7491 13.86C12.0424 13.74 12.3424 13.68 12.6491 13.68C13.1224 13.68 13.5424 13.7833 13.9091 13.99C14.2824 14.19 14.5724 14.4767 14.7791 14.85C14.9857 15.2233 15.0891 15.65 15.0891 16.13C15.0891 16.6167 14.9857 17.0467 14.7791 17.42C14.5791 17.7867 14.2891 18.0733 13.9091 18.28C13.5357 18.48 13.1024 18.58 12.6091 18.58Z" fill="#BF3C00"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_11503_9263">
                            <rect width="22" height="26" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="ap-btn play" id="ap-play">
                        <svg id="ap-icon" width="20" height="20" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                    <div class="ap-btn" id="ap-fwd">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26" viewBox="0 0 22 26" fill="none">
                            <g clip-path="url(#clip0_11503_9272)">
                                <path d="M20.2604 10.7296C21.1127 12.8239 21.2301 15.1453 20.5934 17.315C19.9567 19.4846 18.6034 21.3745 16.7544 22.6761C14.9055 23.9777 12.67 24.6142 10.4127 24.4819C8.15541 24.3495 6.00961 23.456 4.32545 21.9473C2.64128 20.4385 1.51817 18.4034 1.13938 16.1742C0.760585 13.945 1.14847 11.6533 2.23975 9.67286C3.33102 7.69246 5.06126 6.14037 7.14812 5.26984C9.23499 4.3993 11.5553 4.26173 13.7304 4.87955" stroke="#BF3C00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 1.5L14 5L10 8.5" stroke="#BF3C00" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M8.28523 13.1H6.75523V12.51C7.27523 12.5033 7.63857 12.4767 7.84523 12.43C8.0519 12.3767 8.19523 12.2733 8.27523 12.12C8.35523 11.9667 8.41523 11.69 8.45523 11.29H9.02523V18.5H8.28523V13.1ZM12.6091 18.58C11.9157 18.58 11.3357 18.4 10.8691 18.04C10.4024 17.6733 10.1257 17.1767 10.0391 16.55L10.7291 16.39H10.7691C10.8357 16.87 11.0324 17.2467 11.3591 17.52C11.6857 17.7933 12.0991 17.93 12.5991 17.93C13.1191 17.93 13.5357 17.7633 13.8491 17.43C14.1624 17.0967 14.3191 16.6633 14.3191 16.13C14.3191 15.57 14.1557 15.1267 13.8291 14.8C13.5091 14.4667 13.0757 14.3 12.5291 14.3C11.8624 14.3 11.3391 14.6067 10.9591 15.22H10.2591L10.7991 11.29H14.7891V11.94H11.3391L11.0091 14.31C11.2091 14.1233 11.4557 13.9733 11.7491 13.86C12.0424 13.74 12.3424 13.68 12.6491 13.68C13.1224 13.68 13.5424 13.7833 13.9091 13.99C14.2824 14.19 14.5724 14.4767 14.7791 14.85C14.9857 15.2233 15.0891 15.65 15.0891 16.13C15.0891 16.6167 14.9857 17.0467 14.7791 17.42C14.5791 17.7867 14.2891 18.0733 13.9091 18.28C13.5357 18.48 13.1024 18.58 12.6091 18.58Z" fill="#BF3C00"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_11503_9272">
                                    <rect width="22" height="26" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <a href="https://integrations.yourst.agency/api/download-url?url=${src}" id="ap-dl" class="ap-download">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22" fill="none">
                            <path d="M8 14.4V0.5C8 0.367392 8.05268 0.240215 8.14645 0.146447C8.24021 0.0526784 8.36739 0 8.5 0C8.63261 0 8.75979 0.0526784 8.85355 0.146447C8.94732 0.240215 9 0.367392 9 0.5V14.1L14.4 9.1C14.5061 9.02044 14.6394 8.98627 14.7707 9.00502C14.902 9.02378 15.0204 9.09391 15.1 9.2C15.1796 9.30609 15.2137 9.43944 15.195 9.57071C15.1762 9.70199 15.1061 9.82043 15 9.9L8.2 16.1L2.1 9.7C2.02779 9.60371 1.99273 9.48461 2.00126 9.36456C2.00979 9.2445 2.06134 9.13155 2.14645 9.04645C2.23155 8.96134 2.3445 8.90979 2.46456 8.90126C2.58461 8.89273 2.70371 8.92779 2.8 9L8 14.4ZM17 21.5C17 21.8 16.8 22 16.5 22H0.5C0.367392 22 0.240215 21.9473 0.146447 21.8536C0.0526784 21.7598 0 21.6326 0 21.5C0 21.3674 0.0526784 21.2402 0.146447 21.1464C0.240215 21.0527 0.367392 21 0.5 21H16.5C16.8 21 17 21.2 17 21.5Z" fill="#BF3C00" stroke="#BF3C00" stroke-width="0.5"/>
                        </svg>
                    </a>
                </div>
            `;

            let fmt = function (s) {
                s = Math.floor(s || 0);
                return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
            };

          let elCur = container.querySelector('#ap-cur');
          let elTotal = container.querySelector('#ap-total');
          let elFill = container.querySelector('#ap-fill');
          let elThumb = container.querySelector('#ap-thumb');
          let elPlay = container.querySelector('#ap-play');
          let elIcon = container.querySelector('#ap-icon');
          let elSpeed = container.querySelector('#ap-speed');
          let elBar = container.querySelector('#ap-bar');

          audio.addEventListener('loadedmetadata', function () {
            elTotal.textContent = fmt(audio.duration);
          });

          audio.addEventListener('timeupdate', function () {
            let pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
            elFill.style.width = pct + '%';
            elThumb.style.left = pct + '%';
            elCur.textContent = fmt(audio.currentTime);
          });

          elPlay.addEventListener('click', function () {
            if (audio.paused) {
              audio.play();
              elIcon.innerHTML = '<path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>';
            } else {
              audio.pause();
              elIcon.innerHTML = '<path d="M8 5v14l11-7z"/>';
            }
          });

          container.querySelector('#ap-back').addEventListener('click', function () {
            audio.currentTime = Math.max(0, audio.currentTime - 15);
          });

          container.querySelector('#ap-fwd').addEventListener('click', function () {
            audio.currentTime = Math.min(audio.duration, audio.currentTime + 15);
          });

          elSpeed.addEventListener('click', function () {
            speedIdx = (speedIdx + 1) % speeds.length;
            audio.playbackRate = speeds[speedIdx];
            elSpeed.textContent = 'x' + speeds[speedIdx];
          });

          let seek = function (e) {
            let r = elBar.getBoundingClientRect();
            let x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
            audio.currentTime = Math.max(0, Math.min(audio.duration, (x / r.width) * audio.duration));
          };
          let dragging = false;
          elBar.addEventListener('mousedown', function (e) {
            dragging = true;
            seek(e);
          });
          document.addEventListener('mousemove', function (e) {
            if (dragging) seek(e);
          });
          document.addEventListener('mouseup', function () {
            dragging = false;
          });
          elBar.addEventListener('touchstart', seek, { passive: true });
          elBar.addEventListener('touchmove', seek, { passive: true });
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const imgs = document.querySelectorAll('.cta-images img');
    const btns = document.querySelectorAll('.cta-contents__tabs__wrapper button.nav-link');

    let currentImg = document.querySelector('.cta-images img.show');
    let cleanupTimeout = null;

    btns.forEach(btn => {
      btn.addEventListener('shown.bs.tab', function (event) {
        const nextImg = document.querySelector(event.target.getAttribute('data-image'));
        if (!nextImg || nextImg === currentImg) return;

        if (cleanupTimeout) {
          clearTimeout(cleanupTimeout);
          cleanupTimeout = null;
          imgs.forEach(img => {
            if (img !== currentImg) {
              img.classList.remove('show');
              img.style.transform = '';
              img.style.opacity = '';
              img.style.transition = '';
            }
          });
        }

        const allImgs = [...imgs];
        const currentIndex = allImgs.indexOf(currentImg);
        const nextIndex = allImgs.indexOf(nextImg);

        if (nextIndex > currentIndex) {
          nextImg.style.transform = 'translateY(100%)';
          nextImg.style.opacity = '0';
          nextImg.style.transition = 'none';
          nextImg.classList.add('show');

          nextImg.getBoundingClientRect();

          nextImg.style.transition = '';
          nextImg.style.transform = 'translateY(0)';
          nextImg.style.opacity = '1';
          currentImg.style.transform = 'translateY(-100%)';
          currentImg.style.opacity = '0';

        } else {
          nextImg.style.transform = 'translateY(-100%)';
          nextImg.style.opacity = '0';
          nextImg.style.transition = 'none';
          nextImg.classList.add('show');

          nextImg.getBoundingClientRect();

          nextImg.style.transition = '';
          nextImg.style.transform = 'translateY(0)';
          nextImg.style.opacity = '1';
          currentImg.style.transform = 'translateY(100%)';
          currentImg.style.opacity = '0';
        }

        const prevImg = currentImg;
        currentImg = nextImg;

        cleanupTimeout = setTimeout(() => {
          prevImg.classList.remove('show');
          prevImg.style.transform = '';
          prevImg.style.opacity = '';
          prevImg.style.transition = '';
          cleanupTimeout = null;
        }, 920);
      });
    });

    if (document.querySelector('.cta-tabs__pills__action')) {
      document.querySelector('.cta-tabs__pills__action').addEventListener('click', function () {
        this.classList.toggle('active');
        this.nextElementSibling.classList.toggle('visible');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const desktopBlocks = document.querySelector('.header-mega__menu__items');
    const mobileTarget = document.querySelector('.header-mobile__menu');

    if (desktopBlocks && mobileTarget) {
      const clone = desktopBlocks.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      mobileTarget.appendChild(clone);
    }

    for (const menuItem of document.querySelectorAll('.header-mobile__menu .mega-menu__item')) {
      menuItem.addEventListener('click', function () {
        this.classList.toggle('active-menu');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info"] && !Shopify.designMode) return;
  try {
    
    const swiper = new Swiper(".info-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: false,
    navigation: false,
    pagination: false,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    breakpoints: {
        0: {
          slidesPerView: 1.8,
          spaceBetween: 5
        },
        768: {
        slidesPerView: 4,
        spaceBetween: 20
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-shopping"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function getNextSundayAt2030() {
    const now = new Date();
    const target = new Date(now);

    const dayOfWeek = now.getDay();
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;

    target.setDate(now.getDate() + daysUntilSunday);
    target.setHours(20, 30, 0, 0);

    if (target <= now) {
      target.setDate(target.getDate() + 7);
    }

    return target;
  }

  function initCountdown(countdownEl) {
    const targetDate = getNextSundayAt2030();
    let countdownInterval;

    function updateCountdown() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        clearInterval(countdownInterval);
        initCountdown(countdownEl);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      countdownEl.querySelector('.cd-days').textContent = `${days.toString().padStart(2, '0')}j`;
      countdownEl.querySelector('.cd-hours').textContent = `${hours.toString().padStart(2, '0')}h`;
      countdownEl.querySelector('.cd-minutes').textContent = `${minutes.toString().padStart(2, '0')}min`;
      countdownEl.querySelector('.cd-seconds').textContent = `${seconds.toString().padStart(2, '0')}s`;
    }

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  document.querySelectorAll('.live-shopping__countdown').forEach(initCountdown);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blogs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    
    const articlesList = document.querySelector('#articles-list');
    const defaultPagination = document.getElementById('default-pagination');

    let debounceTimer;

    async function searchArticles(query) {

      const graphqlQuery = `
        query searchArticles($query: String!) {
          blog(handle: "articles-guides") {
            articles(first: 100, query: $query) {
              edges {
                node {
                  handle
                  title
                  publishedAt
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
      `;

      try {
        articlesList.style.opacity = '0.5';

        const response = await fetch(`https://www.oodaj.com/api/2024-01/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
          },
          body: JSON.stringify(
            { 
              query: graphqlQuery,
              variables: {
                query: `title:${query}`
              }
            }
          ),
        });

        const data = await response.json();

        const allEdges = data?.data?.blog?.articles?.edges || [];

        const articles = allEdges.filter(({ node }) => 
          node.title.toLowerCase().includes(query.toLowerCase())
        );
        
        renderArticles(articles);
      } catch (err) {
        console.error('Storefront API error:', err);
      } finally {
        articlesList.style.opacity = '1';
      }
    }

    function timeAgo(publishedAt) {
      const now = Math.floor(Date.now() / 1000);
      const articleDate = Math.floor(new Date(publishedAt).getTime() / 1000);
      const diffSeconds = now - articleDate;

      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffSeconds / 3600);
      const diffDays = Math.floor(diffSeconds / 86400);

      if (diffMinutes < 60) {
        return `Il y a ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
      } else if (diffHours < 24) {
        return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
      } else if (diffDays < 7) {
        return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
      } else if (diffDays < 30) {
        const diffWeeks = Math.floor(diffDays / 7);
        return `Il y a ${diffWeeks} semaine${diffWeeks > 1 ? 's' : ''}`;
      } else if (diffDays < 365) {
        const diffMonths = Math.floor(diffDays / 30);
        return `Il y a ${diffMonths} mois`;
      } else {
        const diffYears = Math.floor(diffDays / 365);
        return `Il y a ${diffYears} an${diffYears > 1 ? 's' : ''}`;
      }
    }

    function readingTime(content) {
      const words = content.replace(/<[^>]*>/g, '').trim().split(/\s+/);
      const wordCount = words.filter(Boolean).length;
      const minutes = Math.max(1, Math.floor(wordCount / 200));
      return { minutes, wordCount };
    }

    function renderArticles(articles) {
      defaultPagination.style.display = 'none';

      if (articles.length === 0) {
        articlesList.innerHTML = `
          <div class="col-12 text-center" style="padding: 60px 0;">
            <p>Aucun article trouvé.</p>
          </div>
        `;
        return;
      }

      const html = articles.map(({ node }) => {
      const { minutes, wordCount } = readingTime(node.content || '');

      return `
        <div class="col-lg-3">
          <article class="blog-blogs__article">
            <a href="/blogs/articles-guides/${node.handle}" class="blog-blogs__article_url"></a>
            <h4 class="fw-normal second-font">${node.title}</h4>
            <div class="blog-blogs__article__contents">
              ${node.image ? `
                <img src="${node.image.url}" alt="${node.image.altText || node.title}" style="width:100%;height:auto;">
              ` : ''}
              <p class="blog-blogs__article_excerpt">
                ${node.subTitle || ''}
              </p>
            </div>
            <div class="blog-blogs__article__times">
              <time>${timeAgo(node.publishedAt)}</time>
              <span class="reading-time">
                ${minutes} min de lecture
                <small>(${wordCount} mots)</small>
              </span>
            </div>
          </article>
        </div>
      `;
    }).join('');

      articlesList.innerHTML = `${html}`;
    }

    document.querySelector('.blog-search input').addEventListener('input', function () {
      const query = this.value.trim();

      clearTimeout(debounceTimer);

      if (query.length === 0) {
        location.reload();
        return;
      }

      if (query.length < 2) return;

      debounceTimer = setTimeout(() => searchArticles(query), 400);
    });

    document.querySelector('.blog-search button').addEventListener('click', function () {
      searchArticles(this.previousElementSibling.value.trim());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-podcast"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const podcastsList = document.querySelector('#podcasts-list');
    const defaultPagination = document.getElementById('default-pagination');
    const searchInput = document.querySelector('.blog-search input');
    const searchButton = document.querySelector('.blog-search button');

    let debounceTimer;
    let allPodcasts = null;

    function normalizeText(value) {
      return (value || '')
        .replace(/<[^>]*>/g, ' ')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    }

    async function loadPodcasts() {
      if (allPodcasts) return allPodcasts;

      const graphqlQuery = `
        query getPodcastArticles {
          blog(handle: "podcast") {
            articles(first: 250) {
              edges {
                node {
                  handle
                  title
                  excerpt
                  contentHtml
                  publishedAt
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
      `;

      const response = await fetch('https://www.oodaj.com/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query: graphqlQuery }),
      });

      const data = await response.json();

      if (data.errors) {
        console.error('Storefront GraphQL errors:', data.errors);
      }

      allPodcasts = data?.data?.blog?.articles?.edges || [];
      return allPodcasts;
    }

    async function searchArticles(query) {
      try {
        podcastsList.style.opacity = '0.5';

        const podcasts = await loadPodcasts();
        const normalizedQuery = normalizeText(query);

        const results = podcasts.filter(({ node }) => {
          const searchableContent = [node.title, node.excerpt, node.contentHtml].join(' ');

          return normalizeText(searchableContent).includes(normalizedQuery);
        });

        renderArticles(results);
      } catch (err) {
        console.error('Storefront API error:', err);
      } finally {
        podcastsList.style.opacity = '1';
      }
    }

    function timeAgo(publishedAt) {
      const now = Math.floor(Date.now() / 1000);
      const published = Math.floor(new Date(publishedAt).getTime() / 1000);
      const diff = now - published;
      const minutes = Math.floor(diff / 60);
      const hours = Math.floor(diff / 3600);
      const days = Math.floor(diff / 86400);
      const months = Math.floor(days / 30);
      const years = Math.floor(days / 365);

      if (minutes < 1) return "À l'instant";
      if (minutes < 60) return `Il y a ${minutes} minute${minutes > 1 ? 's' : ''}`;
      if (hours < 24) return `Il y a ${hours} heure${hours > 1 ? 's' : ''}`;
      if (days < 30) return `Il y a ${days} jour${days > 1 ? 's' : ''}`;
      if (months < 12) return `Il y a ${months} mois`;
      return `Il y a ${years} an${years > 1 ? 's' : ''}`;
    }

    function renderArticles(articles) {
      defaultPagination.style.display = 'none';

      if (articles.length === 0) {
        podcastsList.innerHTML = `
          <div class="col-12 text-center" style="padding: 60px 0;">
            <p>Aucun article trouvé.</p>
          </div>
        `;
        return;
      }

      podcastsList.innerHTML = articles
        .map(
          ({ node }) => `
        <div class="col-lg-3">
          <article class="blog-podcast__article mb-5 mb-lg-0">
            ${
              node.image
                ? `
              <a href="/blogs/podcast/${node.handle}">
                <img src="${node.image.url}" alt="${node.image.altText || node.title}" style="width:100%;height:auto;">
              </a>
            `
                : ''
            }
            <time class="third-font d-block">${timeAgo(node.publishedAt)}</time>
            <h4 class="fw-normal second-font">
              <a href="/blogs/podcast/${node.handle}" style="color:inherit;text-decoration:none;">
                ${node.title}
              </a>
            </h4>
          </article>
        </div>
      `
        )
        .join('');
    }

    function handleSearch() {
      const query = searchInput.value.trim();

      clearTimeout(debounceTimer);

      if (!query) {
        location.reload();
        return;
      }

      debounceTimer = setTimeout(() => searchArticles(query), 400);
    }

    searchInput.addEventListener('input', handleSearch);
    searchButton.addEventListener('click', handleSearch);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-password"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.page-password__form__submit').addEventListener('click', function () {

        const password = document.querySelector('.page-password__form__input').value;

        if (password != '') {
            const formData = new FormData();

            formData.set('password', password);

            formData.set('page_id', (new URLSearchParams(location.search)).get('page'));

            fetch('https://integrations.yourst.agency/api/protected-page', {
                method: 'POST',
                body: formData
            })
            .then((resp) => {
                return resp.json();
            })
            .then((data) => {
                if(!data.success) {
                    data.errors.forEach(error => {
                        document.querySelector('.page-password__form__errors').append(error);
                    });
                } else {
                    localStorage.setItem('is_passed', '1');
                    location.href = `${location.origin}/pages/${data.handl}`;
                }
            });
        }

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-choice-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const medias = document.querySelectorAll('.choice-cta__images .choice-cta__media');
    const btns = document.querySelectorAll('.choice-cta__tabs__wrapper button.nav-link');

    if (!medias.length) return;

    let currentMedia = medias[0];
    currentMedia.classList.add('show');

    if (currentMedia.tagName === 'VIDEO') {
      currentMedia.play().catch(() => {});
    }

    let cleanupTimeout = null;

    btns.forEach((btn) => {
      btn.addEventListener('shown.bs.tab', function (event) {
        const nextMedia = document.querySelector(event.target.getAttribute('data-image'));
        if (!nextMedia || nextMedia === currentMedia) return;

        if (cleanupTimeout) {
          clearTimeout(cleanupTimeout);
          cleanupTimeout = null;
          medias.forEach((media) => {
            if (media !== currentMedia) {
              media.classList.remove('show');
              media.style.transform = '';
              media.style.opacity = '';
              media.style.transition = '';
            }
          });
        }

        const allMedias = [...medias];
        const currentIndex = allMedias.indexOf(currentMedia);
        const nextIndex = allMedias.indexOf(nextMedia);

        if (nextMedia.tagName === 'VIDEO') {
          nextMedia.currentTime = 0;
          nextMedia.play().catch(() => {});
        }

        if (nextIndex > currentIndex) {
          nextMedia.style.transform = 'translateY(100%)';
          nextMedia.style.opacity = '0';
          nextMedia.style.transition = 'none';
          nextMedia.classList.add('show');

          nextMedia.getBoundingClientRect();

          nextMedia.style.transition = '';
          nextMedia.style.transform = 'translateY(0)';
          nextMedia.style.opacity = '1';
          currentMedia.style.transform = 'translateY(-100%)';
          currentMedia.style.opacity = '0';
        } else {
          nextMedia.style.transform = 'translateY(-100%)';
          nextMedia.style.opacity = '0';
          nextMedia.style.transition = 'none';
          nextMedia.classList.add('show');

          nextMedia.getBoundingClientRect();

          nextMedia.style.transition = '';
          nextMedia.style.transform = 'translateY(0)';
          nextMedia.style.opacity = '1';
          currentMedia.style.transform = 'translateY(100%)';
          currentMedia.style.opacity = '0';
        }

        const prevMedia = currentMedia;
        currentMedia = nextMedia;

        cleanupTimeout = setTimeout(() => {
          prevMedia.classList.remove('show');
          prevMedia.style.transform = '';
          prevMedia.style.opacity = '';
          prevMedia.style.transition = '';

          if (prevMedia.tagName === 'VIDEO') {
            prevMedia.pause();
          }

          cleanupTimeout = null;
        }, 920);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  new Swiper('.products-slider__items', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
      navigation: {
        nextEl: '.products-slider__items .swiper-button-next',
        prevEl: '.products-slider__items .swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

    breakpoints: {
      0: {
        slidesPerView: 1.1,
      },
      520: {
        slidesPerView: 2.8,
      },
      790: {
        slidesPerView: 3.3,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-podcast"] && !Shopify.designMode) return;
  try {
    
  new Swiper('.blog-podcast__slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.blog-podcast__slider .swiper-button-next',
      prevEl: '.blog-podcast__slider .swiper-button-prev',
    },

    pagination: {
      el: '.blog-podcast__slider .swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 1.1,
      },
      520: {
        slidesPerView: 1.8,
      },
      790: {
        slidesPerView: 3.3,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.slider-article__items', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.slider-article__items .swiper-button-next',
        prevEl: '.slider-article__items .swiper-button-prev',
      },
      pagination: false,
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          centeredSlides: false,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.slider-blog__articles', {
      autoHeight: false,
      slidesPerView: 2,
      spaceBetween: 20,
      loop: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.slider-blog__navs .swiper-button-next',
        prevEl: '.slider-blog__navs .swiper-button-prev',
      },
      pagination: false,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.5,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('#slider-pills-tab .nav-link');

    tabButtons.forEach(function (btn) {
      btn.addEventListener('shown.bs.tab', function (e) {
        const targetId = e.target.getAttribute('data-bs-target').replace('#', '');

        document.querySelectorAll('.slider-products__pills__contents__wrapper').forEach(function (w) {
          w.classList.remove('active');
        });

        const activeWrapper = document.querySelector(
          `.slider-products__pills__contents__wrapper[data-tab-wrapper="${targetId}"]`
        );
        if (activeWrapper) activeWrapper.classList.add('active');
      });
    });

    new Swiper('.slider-products__pills__contents_products', {
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 1.5,
        },
        1025: {
          slidesPerView: 2.5,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.testimonials__items', {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: false,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.5,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
